import { IGoogleTagManager, IResponseGoogleTagManager } from '../types/googleTagManager';

export const googleTagManagerCast = (data: IResponseGoogleTagManager): IGoogleTagManager => {
  return {
    head: String(data.google_tag_manager_head || ''),
    body: String(data.google_tag_manager_body || ''),
  };
};
